import _defineProperty from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/circleci/project/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { validateSettings } from './validation';
import { assertNever } from '../utils';
import { normalizeShouldLoadSegment } from './load-context';
import { AnalyticsService } from './analytics';
import { logger } from './logger';
export var createWrapper = function createWrapper() {
  for (var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
    _ref[_key] = arguments[_key];
  }
  var createWrapperSettings = _ref[0];
  validateSettings(createWrapperSettings);
  var shouldDisableSegment = createWrapperSettings.shouldDisableSegment,
    getCategories = createWrapperSettings.getCategories,
    shouldLoadSegment = createWrapperSettings.shouldLoadSegment,
    integrationCategoryMappings = createWrapperSettings.integrationCategoryMappings,
    shouldEnableIntegration = createWrapperSettings.shouldEnableIntegration,
    registerOnConsentChanged = createWrapperSettings.registerOnConsentChanged,
    shouldLoadWrapper = createWrapperSettings.shouldLoadWrapper,
    enableDebugLogging = createWrapperSettings.enableDebugLogging;
  return function (analytics) {
    var analyticsService = new AnalyticsService(analytics, {
      integrationCategoryMappings: integrationCategoryMappings,
      shouldEnableIntegration: shouldEnableIntegration,
      getCategories: getCategories
    });
    if (enableDebugLogging) {
      logger.enableDebugLogging();
    }
    var loadWrapper = (shouldLoadWrapper === null || shouldLoadWrapper === void 0 ? void 0 : shouldLoadWrapper()) || Promise.resolve();
    void loadWrapper.then(function () {
      // Call this function as early as possible. OnConsentChanged events can happen before .load is called.
      registerOnConsentChanged === null || registerOnConsentChanged === void 0 ? void 0 : registerOnConsentChanged(function (categories) {
        return (
          // whenever consent changes, dispatch a new event with the latest consent information
          analyticsService.consentChange(categories)
        );
      });
    });
    // Create new load method to handle consent that will replace the original on the analytics instance
    var loadWithConsent = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(settings, options) {
        var _options;
        var loadCtx, _loadCtx$abortLoadOpt;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Prevent stale page context by handling initialPageview ourself.
              // By calling page() here early, the current page context (url, etc) gets stored in the pre-init buffer.
              // We then set initialPageView to false when we call the underlying analytics library, so page() doesn't get called twice.
              if ((_options = options) !== null && _options !== void 0 && _options.initialPageview) {
                analyticsService.page();
                options = _objectSpread(_objectSpread({}, options), {}, {
                  initialPageview: false
                });
              }
              // do not load anything -- segment included
              _context.next = 3;
              return shouldDisableSegment === null || shouldDisableSegment === void 0 ? void 0 : shouldDisableSegment();
            case 3:
              if (!_context.sent) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _context.next = 7;
              return loadWrapper;
            case 7:
              _context.next = 9;
              return normalizeShouldLoadSegment(shouldLoadSegment)();
            case 9:
              loadCtx = _context.sent;
              if (!loadCtx.isAbortCalled) {
                _context.next = 13;
                break;
              }
              if (((_loadCtx$abortLoadOpt = loadCtx.abortLoadOptions) === null || _loadCtx$abortLoadOpt === void 0 ? void 0 : _loadCtx$abortLoadOpt.loadSegmentNormally) === true) {
                analyticsService.load(settings, options);
              }
              return _context.abrupt("return", undefined);
            case 13:
              // register listener to stamp all events with latest consent information
              analyticsService.configureConsentStampingMiddleware();
              // if opt-out, we load as usual and then rely on the consent blocking middleware to block events
              // if opt-in, we remove all destinations that are not explicitly consented to so they never load in the first place
              if (!(loadCtx.loadOptions.consentModel === 'opt-in')) {
                _context.next = 20;
                break;
              }
              _context.next = 17;
              return analyticsService.loadWithFilteredDeviceModeDestinations(settings, options);
            case 17:
              return _context.abrupt("return", undefined);
            case 20:
              if (!(loadCtx.loadOptions.consentModel === 'opt-out')) {
                _context.next = 26;
                break;
              }
              analyticsService.configureBlockingMiddlewareForOptOut();
              analyticsService.load(settings, options);
              return _context.abrupt("return", undefined);
            case 26:
              // for typescript exhaustiveness
              assertNever(loadCtx.loadOptions.consentModel);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function loadWithConsent(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    analyticsService.replaceLoadMethod(loadWithConsent);
    return analytics;
  };
};